import React from "react";
import { NavLink, Link, useNavigate } from "react-router-dom";
import { Home, Radio, Music2, BookOpenText, Upload, LogIn, LogOut } from "lucide-react";
import { useAuth } from "../context/AuthContext";

export default function MobileNav() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/login");
  };

  return (
    <>
      {/* Top bar (mobile) */}
      <header className="lg:hidden sticky top-0 z-40 bg-[#060709]/95 backdrop-blur-xl border-b border-[#22262E]">
        <div className="flex items-center justify-between px-4 py-3 gap-3">
          <Link to="/" className="flex items-center gap-2 min-w-0" data-testid="mobile-brand">
            <div className="w-8 h-8 rounded-full bg-gradient-to-br from-[#C5A059] to-[#8B6F35] flex items-center justify-center text-[#060709] font-serif font-bold flex-shrink-0">Y</div>
            <span className="font-serif text-[#FDFBF7] truncate">Yah-Wave Radio</span>
          </Link>
          {!user && (
            <Link to="/login" className="btn-ghost text-sm flex-shrink-0" data-testid="mobile-login-link">
              <LogIn className="w-4 h-4 inline mr-1" strokeWidth={1.5} /> Sign in
            </Link>
          )}
          {user && (
            <div className="flex items-center gap-2 flex-shrink-0">
              <Link to="/submit" className="btn-ghost text-sm" data-testid="mobile-submit-link">
                <Upload className="w-4 h-4 inline mr-1" strokeWidth={1.5} /> Submit
              </Link>
              <button
                onClick={handleLogout}
                data-testid="mobile-logout-btn"
                className="text-xs overline px-3 py-1.5 rounded-full border border-[#C5A059]/30 text-[#C5A059] hover:bg-[#C5A059]/10 flex items-center gap-1"
                aria-label="Sign out"
              >
                <LogOut className="w-3.5 h-3.5" strokeWidth={1.5} /> Sign out
              </button>
            </div>
          )}
        </div>
      </header>

      {/* Bottom nav (mobile) */}
      <nav className="lg:hidden fixed bottom-24 left-0 right-0 z-40 bg-[#060709]/95 backdrop-blur-xl border-t border-[#22262E]">
        <div className="flex items-center justify-around px-2 py-2">
          {[
            { to: "/", icon: Home, label: "Home", testid: "mobile-nav-home" },
            { to: "/radio", icon: Radio, label: "Radio", testid: "mobile-nav-radio" },
            { to: "/music", icon: Music2, label: "Music", testid: "mobile-nav-music" },
            { to: "/sermons", icon: BookOpenText, label: "Sermons", testid: "mobile-nav-sermons" },
            { to: user ? "/submit" : "/login", icon: Upload, label: "Submit", testid: "mobile-nav-submit" },
          ].map(({ to, icon: Icon, label, testid }) => (
            <NavLink
              key={to}
              to={to}
              end={to === "/"}
              data-testid={testid}
              className={({ isActive }) => `flex flex-col items-center gap-1 px-3 py-1 rounded-md ${isActive ? "text-[#C5A059]" : "text-[#A1A4AB]"}`}
            >
              <Icon className="w-5 h-5" strokeWidth={1.5} />
              <span className="text-[10px]">{label}</span>
            </NavLink>
          ))}
        </div>
      </nav>
    </>
  );
}
